import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ImageGallery = ({ images, beanName }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });

  const handlePrevious = () => {
    setSelectedImageIndex((prev) => (prev === 0 ? images?.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setSelectedImageIndex((prev) => (prev === images?.length - 1 ? 0 : prev + 1));
  };

  const handleMouseMove = (e) => {
    if (!isZoomed) return;
    const rect = e?.currentTarget?.getBoundingClientRect();
    const x = ((e?.clientX - rect?.left) / rect?.width) * 100;
    const y = ((e?.clientY - rect?.top) / rect?.height) * 100;
    setZoomPosition({ x, y });
  };

  return (
    <div className="space-y-4">
      <div 
        className="relative bg-muted rounded-lg overflow-hidden cursor-zoom-in" 
        style={{ height: '500px' }}
        onMouseEnter={() => setIsZoomed(true)}
        onMouseLeave={() => setIsZoomed(false)}
        onMouseMove={handleMouseMove}
      >
        <div
          className="w-full h-full transition-transform duration-200"
          style={{
            backgroundImage: `url(${images?.[selectedImageIndex]?.url})`,
            backgroundSize: isZoomed ? '200%' : 'cover',
            backgroundPosition: isZoomed 
              ? `${zoomPosition?.x}% ${zoomPosition?.y}%` 
              : 'center',
            backgroundRepeat: 'no-repeat'
          }}
        />
        
        {images?.length > 1 && (
          <>
            <button
              onClick={handlePrevious}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-card/90 hover:bg-card rounded-full flex items-center justify-center transition-smooth shadow-lg"
              aria-label="Previous image"
            >
              <Icon name="ChevronLeft" size={24} />
            </button>
            
            <button
              onClick={handleNext}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-card/90 hover:bg-card rounded-full flex items-center justify-center transition-smooth shadow-lg"
              aria-label="Next image"
            >
              <Icon name="ChevronRight" size={24} />
            </button>

            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-card/90 px-3 py-1 rounded-full text-sm font-medium">
              {selectedImageIndex + 1} / {images?.length}
            </div>
          </>
        )}
        
        {isZoomed && (
          <div className="absolute top-4 right-4 bg-card/90 px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1">
            <Icon name="ZoomIn" size={14} />
            Hover to zoom
          </div>
        )}
      </div>
      {images?.length > 1 && (
        <div className="grid grid-cols-4 sm:grid-cols-6 gap-2">
          {images?.map((image, index) => (
            <button
              key={index}
              onClick={() => setSelectedImageIndex(index)}
              className={`relative rounded-lg overflow-hidden transition-smooth ${
                selectedImageIndex === index
                  ? 'ring-2 ring-primary' :'opacity-60 hover:opacity-100'
              }`}
              style={{ height: '80px' }}
            >
              <Image
                src={image?.url}
                alt={image?.alt}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageGallery;